const CENTRAL_TIME_ZONE = "America/Chicago";

/** Returns the displayed due date from Waivera's Central calendar date. */
export function calculateInterimTemplateDueDate(
  daysFromCreation: number,
  now: Date = new Date(),
): Date {
  const parts = new Intl.DateTimeFormat("en-US", {
    timeZone: CENTRAL_TIME_ZONE,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).formatToParts(now);
  const value = (type: Intl.DateTimeFormatPartTypes) =>
    Number(parts.find((part) => part.type === type)?.value);
  const dueDate = new Date(value("year"), value("month") - 1, value("day"));
  dueDate.setDate(dueDate.getDate() + daysFromCreation);
  return dueDate;
}
